/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Portfolio } from './Portfolio';
import {
    PortfolioFromJSON,
    PortfolioFromJSONTyped,
    PortfolioToJSON,
} from './Portfolio';

/**
 * 
 * @export
 * @interface PortfolioPage
 */
export interface PortfolioPage {
    /**
     * 
     * @type {number}
     * @memberof PortfolioPage
     */
    totalNr: number;
    /**
     * 
     * @type {Array<Portfolio>}
     * @memberof PortfolioPage
     */
    portfolios: Array<Portfolio>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the PortfolioPage interface.
 */
export function instanceOfPortfolioPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "portfolios" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function PortfolioPageFromJSON(json: any): PortfolioPage {
    return PortfolioPageFromJSONTyped(json, false);
}

export function PortfolioPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalNr': json['total_nr'],
        'portfolios': ((json['portfolios'] as Array<any>).map(PortfolioFromJSON)),
        'asOfDate': json['as_of_date'],
    };
}

export function PortfolioPageToJSON(value?: PortfolioPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_nr': value.totalNr,
        'portfolios': ((value.portfolios as Array<any>).map(PortfolioToJSON)),
        'as_of_date': value.asOfDate,
    };
}

